export default "__VITE_ASSET__aefdc3c1__"